import { TaggedError } from "@for-it/domain-lib";
export class CertificationAlreadyExistsError extends TaggedError {
    constructor() {
        super("CertificationAlreadyExistsError");
    }
}
